// Componente React "invisibile" che fa scroll in alto ad ogni cambio di route.
// Nota per il prossimo dev: non renderizza nulla, serve solo come effetto collaterale.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Ad ogni cambio di pathname, porto lo scroll in cima
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
